(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setSources(video, restore) {
      video.querySelectorAll('source').forEach(function (s) {
        if (restore) {
          if (s.dataset.src) {
            s.setAttribute('src', s.dataset.src);
            s.removeAttribute('data-src');
          }
        } else if (s.getAttribute('src')) {
          s.dataset.src = s.getAttribute('src');
          s.removeAttribute('src');
        }
      });
    }

    function activate(video) {
      setSources(video, true);
      video.setAttribute('preload', 'auto');
      video.load();
      video.play().catch(function () {});
    }

    function deactivate(video) {
      video.pause();
      setSources(video, false);
      video.setAttribute('preload', 'none');
      video.load();
    }

    function sync(heroEl) {
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      heroEl.querySelectorAll('video.hero__video').forEach(function (video) {
        var isMobileVideo = video.classList.contains('hero__video--mobile');
        var shouldPlay = isMobile ? isMobileVideo : !isMobileVideo;
        shouldPlay ? activate(video) : deactivate(video);
      });
    }

    function syncAll() {
      document.querySelectorAll('.hero').forEach(sync);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncAll);
    } else {
      syncAll();
    }

    window.matchMedia('(max-width: 749px)').addEventListener('change', syncAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
